import { ForgeProjectContextMcpUrlSlug, ForgeProjectContextScope, } from "@supernova-studio/model";
import { z } from "zod";
const MAX_SCOPE_BYTES = 1024 * 1024;
// Adds a 1MB wire-format cap on top of the model schema.
export const DTOForgeProjectContextScope = ForgeProjectContextScope.superRefine((scope, ctx) => {
    const size = new TextEncoder().encode(JSON.stringify(scope)).length;
    if (size > MAX_SCOPE_BYTES) {
        ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: "Project context scope must be 1MB or smaller.",
        });
    }
});
export const DTOForgeMcpUrlSlug = ForgeProjectContextMcpUrlSlug;
